export const privacyPolicy = `

<h3>PRIVACY POLICY</h3>
<h4>VILKÅR</h4>

<p>
OrderX AS er ansvarlig for at innsamling av personopplysninger gjennom app og websider foregår på en trygg og sikker måte og i samsvar med gjeldende regelverk. Denne personverklæringen beskriver hvordan vi behandler dine personopplysninger.
</p>

<h4>INNSAMLING OG BEHANDLING AV OPPLYSNINGER</h4>
Når du installerer og bruker appen vår eller bruker vår webapp/webside  vil vi registrere opplysninger som kan knyttes til deg som person. Opplysningene som samles inn og behandles vil være:

<h4>Lokasjon</h4>

<p>
Hvis du installerer appen kan vi spørre deg om mobilenhetens lokasjon. Registrering av lokasjon forutsetter at du har (i) slått på Bluetooth (ii) akseptert lokasjonstjenester i mobilenhetens operativsystem (kun iOS). Du kan når som helst avslutte registreringen av lokasjon gjennom å endre innstillingene, skru av Bluetooth eller ved å avinstallere appen. Du står fritt til å ikke gi oss tilgang til lokasjon. Formålet med å hente lokasjon er å kunne vise deg de nærmeste utsalgsstedene som støtter orderx/ appless.no
</p>

<h4>Informasjon hentet fra mobilenheten </h4>

<p>
Vi kan registrere informasjon som appen henter fra mobilenheten, se punktet om tilganger nedenfor. Hvis du bruker webversjonen av løsningen vår benytter vi cookies for å kunne bruke analyseverktøy som lar oss forstå hvordan kundene bruker løsningen. Vi bruker også cookies til å vise dine tidligere gjennomførte kjøp, siden vi ikke krever noen registrering av personlige opplysninger som for eksempel navn, mobilnummer osv.
</p>

<p>
Formålet med å analysere hvordan brukerne oppfører seg , er å  videreutvikle, forenkle og forbedre våre tjenester.
</p>

<h4>Brukerinformasjon</h4>

<p>Dersom du velger å lage et brukernavn(som ikke er påkrevd for å kjøpe i løsningen), vil vi lagre:</p>

<ul>
<li>Fornavn</li>
<li>Etternavn</li>
<li>E-post</li>
<li>Mobilnummer</li>
</ul>

<p>
Formålet er å kunne opprette en gyldig verifisert bruker i løsningen, slik at vi kan gi deg tilgang for eksempel til tidligere kvitteringer. Vi vil slette brukerinformasjonen din hvis det er mer enn 9 måneder siden sist du benyttet kontoen din.
</p>
<p>OrderX kan bruke informasjonen som samles inn gjennom appen sammen med andre opplysninger vi har registrert om deg.</p>

<h4>TILGANGER</h4>
<p>Appen kan be deg om følgende tilganger fra mobilenheten:</p>

<ul>
<li>Lokasjon</li>
<li>Varslinger</li>
<li>Blåtann</li>
</ul>

<h4>INNSYN</h4>
<p>
Du har rett til å kreve innsyn i hvilke personopplysninger som er lagret hos OrderX. En slik begjæring om innsyn kan fremsettes ved å kontakte oss som beskrevet nedenfor.
</p>

<h4>Deling av data</h4>
<p>
Vi deler kun data relatert til din bruk av løsningen med relevante og nødvendige samarbeidspartnere som trengs for å kunne gjennomføre en transaksjon. Vi har databehandleravtale med alle nødvendige parter. Vi vil aldri selge data relatert til din bruk til 3. parter, verken som isolerte data eller aggregerte data.
</p>



<h4>SLETTING</h4>
<p>
Dine personopplysninger vil bli lagret så lenge det er nødvendig for å oppfylle formålet med behandlingen, deretter vil de bli slettet. Du har rett til å kreve at vi sletter dine personopplysninger når som helst. Krav om sletting av personopplysningene kan fremsettes ved å kontakte oss som beskrevet nedenfor.
</p>

<h4>SIKKERHET</h4>
<p>
Vi bruker flere sikkerhetsteknologier for å beskytte informasjonen mot uautorisert tilgang, blant annet ved at lagring skjer på servere med begrenset tilgang og som står i overvåkede lokaler. Overføring av personopplysninger over Internett er alltid beskyttet ved hjelp av kryptering.
</p>

<h4>ENDRINGER</h4>
<p>
Vi vil kunne gjøre endringer i personvernerklæringen. Vi vil i så fall informere deg om dette og du vil få mulighet til å slutte å bruke tjenesten.
</p>

<h4>KONTAKT</h4>
<p>
Dersom du ønsker å kontakte oss for å få innsyn i hvilke personopplysninger som er lagret må du av sikkerhetsmessige grunner sende inn en skriftlig henvendelse med signatur og kopi av legitimasjon med en redegjørelse for hvilke opplysninger du ønsker innsyn i. Henvendelsen kan skannes inn og sendes per e-post til: 
</p>
<p>
hello@orderx.no
</p>

<p>Opplysningene sendes per post til din folkeregistrerte adresse.</p>
`;
